// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-head {
  margin-bottom: 22px;
}

.page-head-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
}

.page-title {
  font-size: clamp(1.35rem, 2.6vw, 1.75rem);
  font-weight: 800;
  line-height: 1.2;
}

.page-sub {
  margin-top: 5px;
  font-size: 0.92rem;
  line-height: 1.6;
  color: var(--muted);
}

.page-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  font-size: 0.86rem;
  font-weight: 600;
  color: var(--muted);
  text-decoration: none;
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
}

.page-back:hover {
  color: var(--brand);
}

.card {
  padding: 20px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}

.card-title {
  font-family: var(--font-display);
  font-size: 1.02rem;
  font-weight: 700;
  margin-bottom: 4px;
}

.card-sub {
  font-size: 0.87rem;
  line-height: 1.6;
  color: var(--muted);
}

.stack {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.grid-auto {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 11px;
  border-radius: var(--radius-pill);
  font-family: var(--font-display);
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.2px;
  white-space: nowrap;
}

.badge-open {
  background: var(--brand-100);
  color: var(--brand-800);
}

.badge-in_progress {
  background: #fef3c7;
  color: #92400e;
}

.badge-completed {
  background: #d1fae5;
  color: #065f46;
}

.badge-cancelled {
  background: var(--danger-100);
  color: var(--danger-700);
}

.badge-stopped {
  background: var(--border);
  color: var(--muted);
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.chip {
  padding: 7px 13px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-pill);
  background: #fff;
  font-family: var(--font-display);
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--muted);
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s, color 0.2s;
}

.chip:hover {
  border-color: var(--brand-300);
  color: var(--brand);
}

.chip-on,
.chip-on:hover {
  border-color: var(--brand);
  background: var(--brand);
  color: #fff;
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  padding: 44px 22px;
  background: var(--surface);
  border: 1px dashed var(--border-strong);
  border-radius: var(--radius-lg);
}

.empty-ico {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--brand-50);
  color: var(--brand);
}

.empty strong {
  font-family: var(--font-display);
  font-size: 1.02rem;
}

.empty p {
  max-width: 380px;
  font-size: 0.89rem;
  line-height: 1.6;
  color: var(--muted);
}

.meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
  font-size: 0.84rem;
  color: var(--muted);
}

.meta-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.skel {
  border-radius: var(--radius-sm);
  background: linear-gradient(90deg, var(--border) 25%, #eef1f8 50%, var(--border) 75%);
  background-size: 200% 100%;
  animation: skel 1.3s ease-in-out infinite;
}

@keyframes skel {
  from {
    background-position: 200% 0;
  }
  to {
    background-position: -200% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skel {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/ui.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4DAA4D;AAC9D;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,iCAAiC;EACjC,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;EAC1B,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,qFAAqF;EACrF,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".page-head {\n  margin-bottom: 22px;\n}\n\n.page-head-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.page-title {\n  font-size: clamp(1.35rem, 2.6vw, 1.75rem);\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.page-sub {\n  margin-top: 5px;\n  font-size: 0.92rem;\n  line-height: 1.6;\n  color: var(--muted);\n}\n\n.page-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 12px;\n  font-size: 0.86rem;\n  font-weight: 600;\n  color: var(--muted);\n  text-decoration: none;\n  background: none;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n}\n\n.page-back:hover {\n  color: var(--brand);\n}\n\n.card {\n  padding: 20px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n\n.card-title {\n  font-family: var(--font-display);\n  font-size: 1.02rem;\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n.card-sub {\n  font-size: 0.87rem;\n  line-height: 1.6;\n  color: var(--muted);\n}\n\n.stack {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.grid-auto {\n  display: grid;\n  gap: 14px;\n  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 11px;\n  border-radius: var(--radius-pill);\n  font-family: var(--font-display);\n  font-size: 0.74rem;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n  white-space: nowrap;\n}\n\n.badge-open {\n  background: var(--brand-100);\n  color: var(--brand-800);\n}\n\n.badge-in_progress {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.badge-completed {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.badge-cancelled {\n  background: var(--danger-100);\n  color: var(--danger-700);\n}\n\n.badge-stopped {\n  background: var(--border);\n  color: var(--muted);\n}\n\n.chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.chip {\n  padding: 7px 13px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-pill);\n  background: #fff;\n  font-family: var(--font-display);\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--muted);\n  cursor: pointer;\n  transition: border-color 0.2s, background 0.2s, color 0.2s;\n}\n\n.chip:hover {\n  border-color: var(--brand-300);\n  color: var(--brand);\n}\n\n.chip-on,\n.chip-on:hover {\n  border-color: var(--brand);\n  background: var(--brand);\n  color: #fff;\n}\n\n.empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 10px;\n  padding: 44px 22px;\n  background: var(--surface);\n  border: 1px dashed var(--border-strong);\n  border-radius: var(--radius-lg);\n}\n\n.empty-ico {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: var(--brand-50);\n  color: var(--brand);\n}\n\n.empty strong {\n  font-family: var(--font-display);\n  font-size: 1.02rem;\n}\n\n.empty p {\n  max-width: 380px;\n  font-size: 0.89rem;\n  line-height: 1.6;\n  color: var(--muted);\n}\n\n.meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 16px;\n  font-size: 0.84rem;\n  color: var(--muted);\n}\n\n.meta-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.skel {\n  border-radius: var(--radius-sm);\n  background: linear-gradient(90deg, var(--border) 25%, #eef1f8 50%, var(--border) 75%);\n  background-size: 200% 100%;\n  animation: skel 1.3s ease-in-out infinite;\n}\n\n@keyframes skel {\n  from {\n    background-position: 200% 0;\n  }\n  to {\n    background-position: -200% 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .skel {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
